import React, { Component } from 'react';
import Error from '../Error/error';
import styles from './auth.module.scss';
import classnames from 'classnames';
import API, { VERIFICATION_VIA_EMAIL } from '../utils/API';
import { strings } from '../utils/translations';
import { Errors } from '../utils/errors';
import Loader from '../Loader/index';
import SixDigitInput from './sixDigitInput.js';
import PrimaryButton from '../Buttons/primaryButton';
import SecondaryButton from '../Buttons/secondaryButton';
import CloseIcon from '../../img/icons/closeIcon';
import { notification } from 'antd'

export default class ForgotPassword extends Component
{
    code = null
    focusSixDigitInput = true
    
    constructor(props)
    {
        super(props);
        
        this.state =
        {
            email: '',
            password: '',
            repeatPassword: '',

            sendingEmail: false,
            emailSent: false,

            sendingCode: false,
            sendingCodeError: false,
            passwordChanged: false,

            showDidntReceiveDialog: false
        }
    }
    
    render()
    {
        const inputView =
            <form>
                <input
                    type="email"
                    className={styles.input}
                    style={{ marginBottom: 8 }}
                    placeholder={ strings('email') }
                    ref='emailInput'
                    value={this.state.email}
                    onChange={e => this.setState({ email: e.target.value })}
                />
                <input
                    type="password"
                    className={styles.input}
                    style={{ marginBottom: 8 }}
                    placeholder={ strings('password') }
                    ref='passwordInput'
                    value={this.state.password}
                    onChange={e => this.setState({ password: e.target.value })}
                />
                <input
                    type="password"
                    className={styles.input}
                    style={{ marginBottom: 8 }}
                    placeholder={ strings('repeatPassword') }
                    value={this.state.repeatPassword}
                    onChange={e => this.setState({ repeatPassword: e.target.value })}
                />

                <PrimaryButton
                    text={strings('changePassword')}
                    onClick={() => this.sendChangePassword()}
                    className={styles.primaryButton}
                />
            </form>
        
        const sendingView =
            <div>
                <Loader />
            </div>;
            
        const sendingCodeErrorView =
            <>
                <Error text={ strings('errorSendingVerificationCode') } />
                
                <div className={styles.errorButtons}>
                    <SecondaryButton
                        text={strings('editCode')}
                        onClick={() => this.setState({ sendingCodeError: false })}
                    />
                    <PrimaryButton
                        text={strings('retry')}
                        onClick={() => this.verifyChangePassword(this.code)}
                    />
                </div>
            </>;
        
        const title = <h3>{ strings('forgotPassword') }</h3>
        const subtitle = (!this.state.passwordChanged) ?
                            <div className={styles.verifyContainer}>
                                <p className={styles.descriptionText}>
                                {
                                    (this.state.sendingEmail) ?
                                    `${strings('sendingVerificationCode')}...`
                                    :
                                    (
                                        (this.state.sendingCode) ?
                                        strings('verifyingYourCode')
                                        :
                                        (
                                            (this.state.emailSent) ?
                                            <>
                                                { strings('verifyEmailText1Secure') }
                                                <strong>{ ` ${this.state.email}, ` }</strong>
                                                { strings('verifyEmailText2Secure') }
                                            </>
                                            :
                                            strings('forgotPasswordSubtitle')
                                        )
                                    )
                                }
                                </p>
                            </div> : null;
                            
                        
        const didntReceiveDialog =
            <div className={styles.alternativeBox}>
                <SecondaryButton
                    text={ strings('cancel') }
                    onClick={() => this.setState({ showDidntReceiveDialog: false })}
                />
                <PrimaryButton
                    text={  strings('resend') }
                    onClick={() =>
                    {
                        this.setState({ showDidntReceiveDialog: false }, () =>
                        {
                            this.sendChangePassword(() =>
                            {
                                notification.error(
                                {
                                    description: strings('codeResent'),
                                    placement: 'top'
                                })
                                
                                this.setState({ error: true })
                            });
                        });
                    }}
                />
            </div>;
        
        const codeView =
            <>
                <div className={styles.box}>
                    <SixDigitInput
                        onCodeChanged={this.onCodeChanged.bind(this)}
                        onCodeFilled={this.onCodeFilled.bind(this)}
                    ></SixDigitInput>
                </div>

                <div onClick={() => this.setState({ showDidntReceiveDialog: true })}>
                        <p className={styles.secondaryText}>
                            <a className={styles.password}>{ strings('didntReceiveCode') }</a>
                        </p>
                </div>
                
                { 
                    this.state.showDidntReceiveDialog &&
                    didntReceiveDialog
                }
            </>;
            
        const verifiedView = 
            <div className={styles.verifyContainer}>
                <p>{ strings('passwordChanged') }</p>
            </div>;
        
            
        let view = inputView;
        
        if (this.state.sendingEmail)
            view = sendingView;
        else if (this.state.emailSent)
            view = codeView;
        
        if (this.state.sendingCode)
            view = sendingView;
        else if (this.state.sendingCodeError)
            view = sendingCodeErrorView;
        else if (this.state.passwordChanged)
            view = verifiedView;
        
        return (
            <>
                <div className={styles.titleContainer}>
                    { title }
                </div>
                { subtitle }
                
                { view }                        
            </>
        );
    }
    
    onCodeChanged(code)
    {
        this.code = code;
    }
    onCodeFilled()
    {
        this.verifyChangePassword(this.code);
    }
    
    validateFields()
    {
        let allOk = true;
        
        if (this.state.email == null || this.state.email.trim().length === 0)
        {
            allOk = false;
        }
        
        if (this.state.password == null || this.state.password.length === 0)
        {
            allOk = false;
        }
        
        if (this.state.repeatPassword == null || this.state.repeatPassword.length === 0)
        {
            allOk = false;
        }
        
        if (this.state.password != null &&
            this.state.repeatPassword != null &&
            this.state.password !== this.state.repeatPassword)
        {
            allOk = false;
        }
        
        
        if (!allOk)
        {
            notification.error(
            {
                description: strings('fillInAllTheFields'),
                placement: 'top'
            })
        }
        
        
        return allOk
    }
    
    sendChangePassword()
    {
        if (!this.validateFields())
            return

        this.setState({ sendingEmail: true, emailSent: false }, () =>
        {
            API.getInstance().changePassword(this.state.email, VERIFICATION_VIA_EMAIL)
            .then(response =>
            {    
                this.setState({ sendingEmail: false, emailSent: true });
            })
            .catch(error =>
            {    
                this.setState({ sendingEmail: false, emailSent: true });                
            });
        });
    }
    verifyChangePassword(code)
    {
        this.setState({ sendingCode: true, sendingCodeError: false, passwordChanged: false }, () =>
        {
            API.getInstance().verifyChangePassword(this.state.email, code, this.state.password)
            .then(response =>
            {
                if (this.props.loginScreen != null)
                    this.props.loginScreen.setLoginEmail(this.state.email);
                
                this.setState({ sendingCode: false, passwordChanged: true }, () =>
                {
                    setTimeout(() =>
                    {
                        this.closeCard();
                        
                        if (this.props.onPasswordChanged != null)
                            this.props.onPasswordChanged();
                            
                    }, 4000);
                });
            })
            .catch(error =>
            {    
                this.setState({ 
                    sendingCode: false,
                    sendingCodeError: true,
                    error: true
                });
                
                notification.error(
                {
                    description: Errors.showAppError(error),
                    placement: 'top'
                })
            });
        });
    }
    
    onBackPressed()
    {
        this.closeCard();
    }
    closeCard()
    {
        if (this.props.closeCard != null)
            this.props.closeCard();
    }
}